import Relay from 'react-relay';
import { BorrowerMutation, LoanMutation } from './mutations';

const borrowerFields = Relay.QL`
  fragment on Borrower {
    id
    name
    address
    city
    state
    zip
    unit
    employment
    employmentLength
    salary
    hourly
    incomeDeclined
    bonus
    commission
    twoYearsAtCurrentJob
    continuityInRole
    lastYearBonus
    twoYearOldBonus
    lastYearCommission
    twoYearOldCommission
    cohabitate
    ownsPrimaryResidence
    residenceSoldPrior
    email
    approximateCreditScore
    firstTimeBuyer
    dateOfBirth
    vaQualification
    hubspotToken
  }
`;

export default {
  fragments: {
    viewer: () => Relay.QL`
      fragment on Viewer {
        id
        primaryBorrower {
          ${borrowerFields}
          ${BorrowerMutation.getFragment('borrower')}
        }
        activeLoan {
          termsAgree
          scenario
          hasCoborrower
          propertyType
          occupancy
          fixed30
          fixed20
          fixed15
          fixed10
          arm5
          arm7
          arm10
          otherProperty
          taxesFiled
          ownsCompany
          paysAlimony
          alimonyPayment
          refiPurpose
          refiCurrentProduct
          refiCurrentRate
          refiLiens
          isGovernmentLoan
          purchasePrice
          downPayment
          downPaymentGift
          creditAgree
          preapprovalState
          cashOutValue
          citizen
          visa
          visaValid
          condoFee
          lawsuit
          previousPreapproval
          acceptedOffer
          loanAddress
          loanUnit
          loanCity
          loanState
          loanZip
          closeDate
          isNewConstruction
          qualifyStart
          hasAgent
          otherOffer
          otherOfferProduct
          otherOfferRate
          advisor
          pitch
          purchaseTimeFrame
          lastFinancingExperience
          ${LoanMutation.getFragment('loan')}
          coborrower(first:1) {
            edges {
              node {
                ${borrowerFields}
                ${BorrowerMutation.getFragment('borrower')}
              }
            }
          }
        }
      }
    `
  }
};



// WEBPACK FOOTER //
// ./src/components/app/fragments.js